import styled from 'styled-components'
import Img from 'gatsby-image'
import { Link } from 'gatsby'

export const Article = styled.div`
  position: relative;
  border-top: 1px solid ${props => props.theme.colors.black};
  display: flex;
  flex-flow: column;
  width: 100%;
  padding: 2.4rem 0 3.2rem;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 2.4rem 0;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  &:last-child {
    border-bottom: 1px solid ${props => props.theme.colors.black};
  }
`

export const ArticleMeta = styled.div`
  flex: 0 1 14.3%;
  display: none;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: block;
  }
`

export const MobileMeta = styled.div`
  display: flex;
  flex: 0 1 100%;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 1.4rem 0 0;

  span {
    flex: 0 1 auto;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`

export const ArticleContent = styled.div`
  flex: 0 1 100%;
  display: flex;
  flex-flow: row wrap;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 1 82.9%;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
`

export const MetaItem = styled.span`
  display: block;
  font-size: 1.4rem;
  font-weight: 300;
  color: ${props => props.theme.colors.brownGrey};
  margin-bottom: 0.5rem;
`

export const Title = styled(Link)`
  color: ${props => props.theme.colors.black};
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 500;
  text-transform: capitalize;
  text-decoration: none;
  margin: 0;

  &:hover {
    color: ${props => props.theme.colors.cobalt};
    text-decoration: underline;

    &::before,
    &::after {
      content: none;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 2.4rem;
    line-height: 1.5;
  }
`

export const Excerpt = styled.p`
  display: none;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: block;
    font-size: 1.4rem;
    padding: 0.5rem 0;
    line-height: 1.6;
  }
`

export const ArticleImage = styled(Img)`
  width: 100%;
  height: auto;
`

export const ArticlePreview = styled.div`
  flex: 0 1 100%;
  order: 2;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 1 50%;
    order: 1;
  }
`

export const ImageLinkWrapper = styled(Link)`
  flex: 0 1 100%;
  order: 1;

  &::before,
  &::after {
    content: none;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 1 40%;
    max-width: 35.2rem;
    order: 2;
  }
`
